var e4 = e4 || {},
    santax = santax || {};
( function () {
    'use strict';
    jQuery( function () {
        santax.init();
    } );
    santax.init = function () {
        santax.thumbnail.init();
        santax.btnContact.init();
    };
    santax.thumbnail = {
        init: function () {
            jQuery( '.santax-play-button' ).on( 'click', function ( event ) {
                var jElement = jQuery( event.target ).closest( '.santax-video-overlay' ),
                    jContainer = jQuery( event.target ).closest( '.santax-video-overlay' );
                
                jElement.each( function () {
                    jElement.hide( 'fast' );
                })
                
            } )
        }
    };
    santax.btnContact = {
        init: function () {
            jQuery( '.js-btn-contact' ).find( 'a.btn' ).on( 'click', function ( event ) {
                event.preventDefault();
                var targetOffset = jQuery( '.js-e-form-dw' ).offset().top;
                var negativeOffset = -300;
                jQuery( 'html, body' ).animate({
                    scrollTop: targetOffset + negativeOffset
                }, 1000);
            })
        }
    }
}() );